import {Component, Input, OnInit} from '@angular/core';
import {FieldConfig} from "../field.interface";
import {UntypedFormGroup} from "@angular/forms";
import {ContentChange} from "ngx-quill";

@Component({
  selector: 'app-text-editor',
  template: `
    <ng-container *ngIf="field">
      <div [formGroup]="group">
        <quill-editor (onContentChanged)="changed($event)" [styles]="editorStyle" style="display: block"
                      [placeholder]="field.placeholder || field.label || ''"
                      [formControlName]="field.key || null"
                      [required]="field.key && group?.get(field.key)?.errors !== null && group?.get(field.key)?.errors?.['required']">
        </quill-editor>
        <span class="text-xs text-red-500 font-semibold" *ngIf="field.maxLength">
          {{ characterCount }} / {{field.maxLength}} Characters
        </span>
        <ng-container *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
          <mat-error *ngIf="field.key && group?.get(field.key)?.hasError(validation.name)">{{ validation.message }}
          </mat-error>
        </ng-container>
      </div>
    </ng-container>
  `
})
export class TextEditorComponent implements OnInit {

  @Input() field?: FieldConfig;

  @Input() group: UntypedFormGroup = new UntypedFormGroup({});

  editorStyle: any;

  characterCount: number = 0;

  constructor() {
  }

  ngOnInit(): void {
    this.editorStyle = {
      height: this.field.textEditorHeight || '150px',
    };
  }

  changed(event: ContentChange) {
    this.characterCount = event.text.length - 1;

    if (!!this.field.maxLength) {
      const text = event.editor.getText().trim();
      this.characterCount = text.length;

      if (this.characterCount > this.field.maxLength) {
        // Truncate the content to the max limit
        const delta = event.editor.getContents();
        const truncated = delta.slice(0, this.field.maxLength);
        event.editor.setContents(truncated);

        // Update the content length after truncation
        this.characterCount = this.field.maxLength;
      }
    }
  }
}
